const requiredParams = [
  "email",
  "studentId",
  "channel",
  "sessionId",
  "transactionReferenceId",
  "paymentId",
  "itemCode",
  "item",
  "amount",
  "callbackUrl",
  "token",
  "signed",
  "courseCode",
  "courseYear",
  "liveChatSessionId",
  "merchantAccountId",
];

function getParam({ key, queryString }) {
  const params = new URLSearchParams(queryString);
  // window.history.replaceState({}, document.title, "/checkout");
  return params.get(key);
}

function formatParams(queryString) {
  const result = {};

  requiredParams.forEach(
    param => (result[param] = getParam({ key: param, queryString }))
  );

  return result;
}

function sanitizeHTML(str) {
  // Remove <script> tags and their content
  const scriptTagPattern = /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi;
  str = str.replace(scriptTagPattern, '');

  // Optionally, remove other potentially dangerous tags (e.g., <iframe>, <style>)
  const otherTagsPattern = /<(\/?)(iframe|style|link|meta|object|embed|form|input|button|textarea|select|option|applet|base|basefont|bgsound|blink|body|layer|marquee|plaintext|xml|xss)(\s+[^>]*)?>/gi;
  str = str.replace(otherTagsPattern, '');

  // Escape other HTML entities to prevent injection
  str = str.replace(/&/g, "&amp;")
           .replace(/</g, "&lt;")
           .replace(/>/g, "&gt;")
           .replace(/"/g, "&quot;")
           .replace(/'/g, "&#039;");

  return str;
}

function validateParams(params) {
  // Ensure params object contains all required params and those params are not empty
  const res = requiredParams.filter(
    reqParam => !params.hasOwnProperty(reqParam) || params[reqParam] == null
  );
  return { data: params, valid: res.length === 0 };
}

// logGroup("validateParams Test", validateParams({
//   "email": "harry.wu@monash.edu",
//   "channel": "web",
//   "sessionId": "51262565729169512",
//   "item": "Digital Letter A",
//   "amount": "20.00",
//   "callbackUrl": "https://httpbin.org/post",
//   "token": "someToken"
// }))

module.exports = {
  requiredParams,
  getParam,
  validateParams,
  formatParams,
  sanitizeHTML
};
